export default __webpack_public_path__ + "static/media/BIDV.135b85f2.jpg";